/* hs-eslint ignored failing-rules */

/* eslint-disable react-hooks/exhaustive-deps */
'use es6';

import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchFeatures } from '../actions/FeatureActions';
import RequestStatus from '../constants/RequestStatus';
import { fetchFeaturesStatus, getAllFeaturesByAllProductLinesSelector } from '../selectors/FeatureSelectors';
import { isUngatedForFeatureStore } from '../selectors/GatingSelectors';
export const useFeatureStore = ({
  highlightedProducts,
  productLine
}) => {
  const dispatch = useDispatch();
  const passedInFeatures = useSelector(getAllFeaturesByAllProductLinesSelector);
  const requestStatus = useSelector(fetchFeaturesStatus);
  const isUngatedForFS = useSelector(isUngatedForFeatureStore);
  const hasProductLineFeatures = passedInFeatures[productLine] && passedInFeatures[productLine].length;
  useEffect(() => {
    if (!isUngatedForFS || !highlightedProducts.length || requestStatus === RequestStatus.PENDING || hasProductLineFeatures) {
      return;
    }

    dispatch(fetchFeatures({
      highlightedProducts,
      productLine
    }));
  }, []);
};